import Title from "../components/sections/Title";
import About from "../components/sections/About";
import SideList from "../components/sections/SideList";
import UsefulFor from "../components/sections/UsefulFor";
import {about, during, usefulFor, usefulForExtra} from "../content/Shiatsu";

const color = "shiatsu";

function Shiatsu(){
    return (
        <main className="flex-grow-1">
            <Title title="Shiatsu&nbsp;technika" color={color}/>
            <About title="Shiatsu" paragraphs={about} color={color}/>
            <SideList id="during" listItems={during} title="Kezelés alatt" secondaryText="(60 perc)" color={color} />
            <UsefulFor listItems={usefulFor} extra={usefulForExtra} color={color} />
        </main>
    );
}

export default Shiatsu;